import EditSuccessStoryContainer from "../containers/EditSuccessStoryContainer";

const EditSuccessStoryPage = () => {
  return (
    <EditSuccessStoryContainer />
  );
};

export default EditSuccessStoryPage;
